import { Box } from "@mui/material"
import './dashboard.scss'
import Typography from "../typography/typography"
import logo from '../../assets/images'
interface Iprops {
    title?: string,
    value?: string | number
}
function DashBoardCard(props: Iprops) {
    const { title, value } = props
    return (
        <>
            <Box className='card-class'>
                <Box p={2} sx={{ display: 'flex', flexDirection: 'column', border: '1px solid', borderRadius: '8px', gap: 1, borderColor: '#EEEFF1' }}>
                    <Box className='dashboard-card-icon'>
                        <img src={logo.ArrowCircleUpIcon} />

                    </Box>
                    <Typography type="s5" weight="normal" color="theme.neutral.800">{title}</Typography>
                    <Typography type="h2" weight="bold" color="theme.neutral.1000">{value}</Typography>
                </Box>
            </Box>
        </>
    )
}


export { DashBoardCard };
export default DashBoardCard